import { useState } from "react";
import { Step1 } from "./Step1";
import { Step3 } from "./Step3";

export default function PasswordReset() {
  const [step, setStep] = useState(1);

  const getStep = (stepId: number) => {
    switch (stepId) {
      case 1:
        return <Step1 setStep={setStep} />;

      case 3:
        return <Step3 />;
    }
  };

  return getStep(step);
}
